// extracted by mini-css-extract-plugin
export var avatar = "H1p9TmGL0Rrou2Sm0P8j";
export var input = "XJVOMTznHR0jsPZTldgs";
export var root = "l6lIsjnNqXhsoyKnW5bG";